"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _bullet = require("@nivo/bullet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_bullet.ResponsiveBullet, _extends({
    data: [],
    rangeColors: "pastel2",
    margin: {
      top: 50,
      right: 90,
      bottom: 50,
      left: 90
    },
    spacing: 46,
    titleAlign: "start",
    titleOffsetX: -70,
    measureSize: 0.2,
    animate: true,
    motionStiffness: 90,
    motionDamping: 12
  }, props));
};

exports["default"] = _default;